import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Days, StoreOpeningHours } from '../../../../global-state/types';
import { Typography } from '../../../../stories/atoms';
import { RowFlexContainer } from '../../../../stories/atoms/containerV2/ContainerV2';
import { commonTranslations } from '../../../../translations';

type OpeningHoursProps = {
  openingHours: StoreOpeningHours[];
};

export const OpeningHours: FC<OpeningHoursProps> = ({ openingHours }) => {
  const { t } = useTranslation();

  return (
    <>
      {openingHours?.map(({ day, exceptions, defaultOpeningHours }) => {
        const dayLabel = t(commonTranslations[day as Days].key, commonTranslations[day as Days].defaultValue);

        const isClosed = exceptions?.isClosedAllDay;
        const openingTime = exceptions?.openingHours?.opens || defaultOpeningHours?.open.opens;
        const closingTime = exceptions?.openingHours?.closes || defaultOpeningHours?.open.closes;

        const isException = Boolean(exceptions);
        const textColor = isException ? 'red' : undefined;

        return (
          <RowFlexContainer justifyContent="between" key={day}>
            <Typography type="body3" color={textColor}>
              {dayLabel}
            </Typography>
            <Typography type="body3" color={textColor}>
              {isClosed
                ? t(commonTranslations.close.key, commonTranslations.close.defaultValue).toUpperCase()
                : `${openingTime} - ${closingTime}`}
            </Typography>
          </RowFlexContainer>
        );
      })}
    </>
  );
};
